import {UploadFile} from "antd/lib/upload/interface";
import { FileUploader, SingleFileUploader } from "digimuth-components/dist";
import { useInjection } from "inversify-react";
import React, {forwardRef, useImperativeHandle, useRef} from "react";
import { FileApi } from "../../../api";
import ApiService from "../../../services/apiService";

type FileUploaderHandle = React.ElementRef<typeof FileUploader>;

function getSingleElementArrayOrEmpty<T>(element?: T): T[] {
    return element ? [element] : [];
}

const BeeftekaFileUploader = forwardRef((props: BeeftekaFileUploaderProps, ref: React.ForwardedRef<any>) => {

    const fileUploaderRef = useRef<FileUploaderHandle>();
    const apiService = useInjection(ApiService);
    const fileApi = apiService.getApi(FileApi);

    useImperativeHandle(ref, () => ({
        async onFormFinish() {
            return await fileUploaderRef.current.onFormFinish();
        }
    }));

    const fileDownloadFunction = async (id: number) => {
        return await fileApi.apiFileIdFileStreamGet(id, {responseType: 'blob'});
    };

    const fileUploadFunction = async (file: UploadFile<any>, httpRequestOptions: any) => {
        return await fileApi.apiFilePost(
            file, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, httpRequestOptions);
    };

    return <SingleFileUploader
        ref={fileUploaderRef}
        defaultFile={props.defaultFile}
        onChange={props.onChange}
        value={props.value}
        accept={props.accept}
        sizeLimitMb={props.sizeLimitMb}
        isFilePublic={props.isFilePublic}
        fileDownloadFunction={fileDownloadFunction}
        fileUploadFunction={fileUploadFunction}
        buttonLabel="Kliknij, aby wskazać plik"
        sizeValidationMessage={`Przekroczono maksymalną dopuszczalną wielkość pliku, która wynosi ${props.sizeLimitMb} MB`}
        uploadFilesCountMessage="Można wgrać maksymalnie jeden plik"
    />
});

export interface BeeftekaFileUploaderProps {
    defaultFile?: UploadFile<any>;
    onChange?: (uploadedFileId?: string, file?: UploadFile<any>) => any;
    value?: number;
    accept?: string;
    sizeLimitMb?: number,
    useOrganisationFileApi?: boolean,
    isFilePublic?: boolean,
}

export default BeeftekaFileUploader;
